import { ProviderExtension } from "../registry";

export const linkedinExtension: ProviderExtension = {
  labels: {
    nativeAudienceLabel: "Mobile Client IDs",
    nativeAudiencePlaceholder: "77abc123def456",
    nativeAudienceHint:
      "Use the OAuth Client ID(s) from linkedin.com/developers/apps.",
    webClientIdLabel: "Client ID",
    webClientIdPlaceholder: "77abc123def456",
  },
};
